import { keyframes, styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 50px;
`;

export const ShareLinkImage = styled.div`
    display: flex;
`;

export const Text = styled.div`
    display: flex;
    margin-top: 20px;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
`;

export const PhoneNumberWrapper = styled.div`
    display: flex;
    margin-top: 8px;
`;

export const PhoneNumber = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
`;

export const EditIcon = styled.div`
    display: flex;
    margin-left: 5px;
`;

export const LinkWrapper = styled.div`
    background: #ffffff;
    border: 1px solid #e7e7f0;
    border-radius: 8px;
    margin-top: 16px;
    padding: 12px;
    word-break: break-all;
    position: relative;
`;

export const Link = styled.span`
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    align-items: center;
    color: #1b73e8;
`;

export const SendButtonWrapper = styled.div`
    margin-top: 40px;
`;

const Appear = keyframes`
  0%{
    opacity : 0
  }
  50%{
    opacity : 1
  }
  51%{
    opacity : 1
  }
  85%{
    opacity : 0;
    display: none;
  }
  100%{
    opacity : 0;
    display: none;
  }
`;

export const Copied = styled.span`
    text-align: center;
    width: max-content;
    box-sizing: border-box;
    color: #0fa457;
    border-radius: 8px;
    font-size: 12px;
    margin-left: 10px;
    animation: ${Appear} 1.5s ease-in-out;
    font-weight: 700;

    position: absolute;
    bottom: -20px;
    left: 0px;
`;
